module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_taxi-a2aab72aa52c50824172bf1c471ff18f.svg";